import templateUrl from "emun.media/media-container.htm";
import controller from "emun.media/media-container.controller";

export default {
  bindings: {
    ngModel: "=?",
    retailerId: "<?",
    mediaId: "<?",
    filters: "<?",
    views: "<?",
    templates: "<?",
    canManage: "<?",
    quickView: "<?",
    mediaId: "<?",
    realm: "@",
    shard: "@",
    hideHeader: "<?",
    hideFooter: "<?",
    hideItemActions: "<?",
    layout: "@",
    disableQueryString: "<",
    mode: "@",
    accept: "@",
    icon: "@",
    size: "@",
    tags: "<?",
    criteria: "<?",
    tagCriteria: "<?",
    onMediaSelected: "&",
    onAdd: "&",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
